import React, { FC } from 'react';
import { FieldRenderProps as WrappedFieldProps } from 'react-final-form';
import { isEmpty } from 'lodash';
import { QuickQuoteFormProps } from '../../booking/quote/QuickQuoteTypes';
import { DatePicker, DatePickerProps } from '@trip-ux/components';

export const GenericDatePicker: FC<WrappedFieldProps<string> & QuickQuoteFormProps & DatePickerProps> = ({
  input,
  labels,
  meta,
  inputOnChange,
  ...datePickerProps
}) => {
  return (
    <DatePicker
      {...input}
      {...datePickerProps}
      defaultValue={input.value}
      labels={labels.calendarLabels}
      errors={meta.dirty || meta.touched ? meta.error : undefined}
      required={true}
      onBlur={val => {
        input.onChange(val);
        inputOnChange && inputOnChange(val);
      }}
      onChange={val => {
        input.onChange(val);
        inputOnChange && inputOnChange(val);
      }}>
      {isEmpty(labels.formLabels['dateFormatLabel']) ? (
        labels.formLabels[input.name]
      ) : (
        <>
          <span className="label-question">{labels.formLabels[input.name]}</span>
          <span className="date-picker-date-format-label">{labels.formLabels['dateFormatLabel']}</span>
        </>
      )}
    </DatePicker>
  );
};
GenericDatePicker.displayName = 'GenericDatePicker';
